import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <h1 className="title">Welcome to Swissring</h1>
      <p className="subtitle">Explore Our Services</p>
      <div className="buttons">
        <Link to="/list/solutions" className="button solutions">Solutions</Link>
        <Link to="/list/products" className="button products">Products</Link>
        <Link to="/list/customers" className="button customers">Services</Link>
      </div>
    </div>
  );
}

export default Home;

